<template>
    <div class="qclist">
        <div class="clearfix qcnav">
            <NavBar
                class="restclass"
                :title="title"
                left-text="返回"
                left-arrow
                @click-left="getBack" />
        </div>

        <div class="clientList">
            <Tabs v-model="activeName" style="padding:0 0 2rem 0" @click="activetab">
                <Tab title="基本信息" name="a">
                    <Form v-model="form" @submit="onSubmit">
                        <van-field

                            v-model="form.vehicleCode"
                            :readonly="form.enumWorkOrderStatus != 1"
                            :required="true"
                            autocomplete="off"
                            :show-error="true"
                            name="车辆编号"
                            label="车辆编号"
                            placeholder="车辆编号"
                            :rules="[ { required: true, message: '必填' } ]"
                            @keyup="queryvehicleCode"
                            @clear="clearvehicleCode" />
                        <van-popup
                            v-model="showpicker"
                            position="bottom"
                            @close="closepopup">
                            <van-picker
                                item-height="1.173rem"
                                show-toolbar
                                :columns="vehicleCodeColumn"
                                @cancel="showpicker = false"
                                @confirm="onConfirm" />
                        </van-popup>
                        <!-- <van-field
                            v-model="form.barCode"
                            disabled
                            :show-error="true"
                            name="条码编号"
                            label="条码编号"
                            placeholder="条码编号" /> -->
                        <van-field
                            v-model="form.barCode"
                            :readonly="form.enumWorkOrderStatus != 1"
                            clearable
                            autocomplete="off"
                            icon="question-o"
                            name="条码编号"
                            label="条码编号"
                            label-class=""
                            :border="true"
                            maxlength="30"
                            placeholder="输入条码编号"
                            :show-error="true"
                            :required="true"
                            :rules="[ { required: true, message: '必填' } ]"
                            bind:click-icon="onClickIcon"
                            @clear="clearbarCode"
                            @keyup="querybarCode" />
                        <van-popup
                            v-model="showbarCode"
                            position="bottom">
                            <van-picker
                                show-toolbar
                                :columns="barCodeColumn"
                                @cancel="showbarCode = false"
                                @confirm="barcodeConfirm" />
                        </van-popup>
                        <van-field
                            v-model="form.category"
                            disabled
                            :show-error="true"
                            name="车辆类别"
                            label="车辆类别"
                            placeholder="车辆类别" />
                        <van-field
                            v-model="form.model"
                            disabled
                            :show-error="true"
                            name="车辆型号"
                            label="车辆型号"
                            placeholder="车辆型号" />
                        <van-field
                            v-model="form.brand"
                            disabled
                            :show-error="true"
                            name="品牌"
                            label="品牌"
                            placeholder="品牌" />
                        <!-- <van-field
                            v-model="form.username"
                            disabled
                            :show-error="true"
                            name="入场日期"
                            label="入场日期"
                            placeholder="入场日期" /> -->
                        <van-field
                            v-model="form.customer"
                            disabled
                            :show-error="true"
                            name="客户名称"
                            label="客户名称"
                            placeholder="客户名称" />

                        <van-field
                            v-model="form.owner"
                            disabled
                            :show-error="true"
                            name="权责人"
                            label="权责人"
                            placeholder="权责人" />
                        <van-field
                            v-model="form.driversnamephone"
                            readonly
                            type="textarea"
                            autosize
                            :show-error="true"
                            name="驾驶员"
                            label="驾驶员"
                            placeholder="驾驶员"
                            @click="queryDrivers" />
                        <van-popup
                            v-model="showdrivers"
                            :style="{ height: '30%' }"
                            position="bottom">
                            <van-checkbox-group v-model="form.checkedDrivers">
                                <van-cell-group>
                                    <van-cell
                                        v-for="(item,index) in driversColumn"
                                        :key="item.id"
                                        clickable
                                        :title="item.driverNamePhone"
                                        @click="toggle(item,index)">
                                        <van-checkbox slot="right-icon" ref="checkboxes" shape="square"
                                            :name="item.driverNamePhone" />
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </van-popup>
                        <div class="nextClass">
                            <Button round block type="info" native-type="submit"
                                class="nextSpan">
                                下一步
                            </Button>
                        </div>
                    </Form>
                </Tab>
                <Tab title="维修信息" name="b" :disabled="tabdisabled">
                    <van-form @submit="onSubmits">
                        <div>
                            <van-panel>
                                <template #header>
                                    <van-cell title="报修信息">
                                        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                                        <template #right-icon>
                                            <!-- <van-icon name="search" style="line-height: inherit;" /> -->
                                            <!-- <van-tag type="danger" @click="routeto">原单据号</van-tag> -->
                                            <span v-if="form.enumWorkOrderType == 2 && title == '返修派工单'" class="button-text" @click="original">原单据号：{{ form.sourceNo }}</span>
                                        </template>
                                    </van-cell>
                                </template>
                                <van-field
                                    v-model="form.enumMaintenanceName"
                                    disabled
                                    :show-error="true"
                                    label="维修类型"
                                    placeholder="维修类型" />
                                <van-field
                                    v-model="form.faultDescription"
                                    rows="1"
                                    autosize
                                    label="故障描述"
                                    type="textarea"
                                    placeholder="故障描述" />
                                <van-checkbox v-model="form.isOnlyRequisitionPart" shape="square" :disabled="form.enumWorkOrderStatus != 1 || form.enumWorkOrderType==2" @change="pickuponly">仅领件</van-checkbox>
                            </van-panel>
                            <van-panel>
                                <template #header>
                                    <van-cell title="维修项目">
                                        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                                        <template #right-icon>
                                            <!-- <van-icon name="search" style="line-height: inherit;" /> -->
                                            <van-tag type="danger" @click="routeto">历史记录</van-tag>
                                        </template>
                                    </van-cell>
                                </template>
                                <van-cell v-for="(item,index) in form.items" v-if="form.items" :key="index" is-link
                                    @click="details(item,index)">
                                    <van-row class="maintainItemClass">
                                        <van-col span="1">
                                            <p>{{ index+1 }}</p>
                                        </van-col>
                                        <van-col span="20">
                                            <p class="listp">
                                                <span class="info-span-bottom">{{ item.maintainItem }}</span>
                                                <span class="info-span-bottom" style="font-size:16px">{{ item.workHour }}</span>

                                            </p>
                                            <p class="listp margin-top5">
                                                <span class="info-span-bottom">{{ `${item.position?item.position:''}-${item.part?item.part:''}` }}</span>
                                            </p>
                                            <p class="listp margin-top5">
                                                <span class="info-span-bottom" style="width:25%">{{ item.teamName }}</span>
                                                <span class="info-span-bottom" style="width:40%">{{ item.workerNames }}</span>
                                                <span class="info-span-bottom" style="width:20%">{{ item.totalPrice }}</span>
                                            </p>
                                        </van-col>
                                        <van-col style="width:10px" span="3"><span type="primary" round>{{ convertStatus(item.enumFaultReason) }}</span></van-col>
                                    </van-row>
                                    <van-cell v-if="form.items.length>0" title="配件明细" />
                                    <el-table v-if="form.items.length>0" :data="item.parts" border style="width: 100%"
                                        :header-cell-class-name="'tq-table-rom-header'" size="mini">
                                        <el-table-column
                                            label="序号"
                                            type="index"
                                            width="49"
                                            align="center" />
                                        <el-table-column
                                            v-if="$route.query.type == '返修结算单'"
                                            prop="isRework"
                                            show-overflow-tooltip
                                            label="是否返修">
                                            <template slot-scope="scope">
                                                <el-switch
                                                    v-model="scope.row.isRework"
                                                    :active-value="1"
                                                    :inactive-value="0"
                                                    @change="handleStatusChange(scope.row.isRework)" />
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="billStatusName" label="状态" width="50">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName?scope.row.billStatusName:'正常' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="customerBillNo" label="出库单号">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName=='缺件'?'-':scope.row.customerBillNo }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="part" label="配件名称" />
                                        <el-table-column prop="num" label="数量" width="50" />
                                        <el-table-column prop="unitPrice" label="单价">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName=='缺件'?'-':scope.row.unitPrice }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="totalPrice" label="合计金额">
                                            <template slot-scope="scope">
                                                {{ scope.row.billStatusName=='缺件'?'-':scope.row.totalPrice }}
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </van-cell>
                            </van-panel>
                            <van-cell v-if="$route.query.type != '返修派工单' && title !='返修派工单' && form.enumWorkOrderStatus!=6 && !form.isOnlyRequisitionPart" border title="添加维修项目" is-link
                                @click="showLists" />
                        </div>
                        <div>
                            <van-popup v-model="showList" position="bottom" :style="{ height: '80%' }" @click-overlay="closeshowList">
                                <van-field
                                    v-model="maintainItemdetails.position"
                                    readonly
                                    :show-error="true"
                                    name="部位"
                                    label="部位"
                                    placeholder="部位"
                                    @click="showpositions = true" />
                                <van-popup
                                    v-model="showpositions"
                                    position="bottom">
                                    <van-picker
                                        item-height="1.173rem"
                                        show-toolbar
                                        :columns="positions"
                                        @cancel="showpositions = false"
                                        @confirm="confirmposition" />
                                </van-popup>
                                <van-field
                                    v-model="maintainItemdetails.part"
                                    readonly
                                    :show-error="true"
                                    name="部件"
                                    label="部件"
                                    placeholder="部件"
                                    @click="bwpart" />
                                <van-popup
                                    v-model="showpart"
                                    position="bottom">
                                    <van-picker
                                        item-height="1.173rem"
                                        show-toolbar
                                        :columns="parts"
                                        @cancel="showpart = false"
                                        @confirm="confirmpart" />
                                </van-popup>
                                <van-field
                                    v-model="maintainItemdetails.maintainItem"
                                    :readonly="projectreadonly"
                                    autocomplete="off"
                                    :show-error="true"
                                    name="maintainItem"
                                    label="维修项目"
                                    placeholder="选择项目"
                                    @click="!projectreadonly ? showmaintainItems = true : showmaintainItems==false"
                                    @input="queryMaintainItem" />
                                <van-popup
                                    v-model="showmaintainItems"
                                    :style="{ height: '35%' }"
                                    position="bottom">
                                    <van-picker
                                        item-height="1.173rem"
                                        show-toolbar
                                        :columns="maintainItemslist"
                                        @cancel="showmaintainItems = false"
                                        @confirm="confirmmaintainItem" />
                                </van-popup>
                                <!-- <van-field
                                    v-model="maintainItemdetails.maintainItemNum"
                                    autocomplete="off"
                                    :show-error="true"
                                    name="maintainItemNum"
                                    label="数量"
                                    placeholder="数量"
                                    @input="maintainItemdetails.maintainItemNum= checkNumberFloat(maintainItemdetails.maintainItemNum)" /> -->
                                <van-row>
                                    <van-col class="num">数量</van-col>
                                    <van-col><van-stepper v-model="maintainItemdetails.maintainItemNum" class="num-stepper" min="1" max="99"
                                        integer /></van-col>
                                </van-row>
                                <van-field
                                    v-model="maintainItemdetails.workHour"
                                    autocomplete="off"
                                    :show-error="true"
                                    name="workHour"
                                    label="工时"
                                    placeholder="工时"
                                    @input="maintainItemdetails.workHour= checkNumberFloat(maintainItemdetails.workHour)" />
                                <van-field
                                    v-model="maintainItemdetails.unitPrice"
                                    autocomplete="off"
                                    :readonly="maintainItemdetails.maintainItemId !=null"
                                    :show-error="true"
                                    name="unitPrice"
                                    label="工时单价"
                                    placeholder="工时单价"
                                    @input="maintainItemdetails.unitPrice= checkNumberFloat(maintainItemdetails.unitPrice)" />
                                <van-field
                                    v-model="maintainItemdetails.teamName"
                                    :required="true"
                                    readonly
                                    :show-error="true"
                                    name="维修队"
                                    label="维修队"
                                    :rules="[ { required: true, message: '必填' } ]"
                                    placeholder="维修队"
                                    @click="teamlist" />
                                <van-popup
                                    v-model="showteam"
                                    position="bottom">
                                    <van-picker
                                        item-height="1.173rem"
                                        show-toolbar
                                        :columns="teamNames"
                                        @cancel="showteam = false"
                                        @confirm="confirmteam" />
                                </van-popup>
                                <!-- <van-field
                            v-model="form.username"
                            disabled
                            :show-error="true"
                            name="入场日期"
                            label="入场日期"
                            placeholder="入场日期" /> -->
                                <div v-for="(item,index) of maintainItemdetails.workOrderMen" :key="index">
                                    <van-row>
                                        <van-col :span="11">
                                            <van-field
                                                v-model="item.workerName"
                                                readonly
                                                label="维修工"
                                                :border="true"
                                                placeholder="请输入" @click="getWorkers(index)" />
                                            <van-popup
                                                v-model="showwork"
                                                :style="{ height: '30%' }"
                                                position="bottom">
                                                <van-picker
                                                    item-height="1.173rem"
                                                    show-toolbar
                                                    :columns="workers"
                                                    @cancel="showwork = false"
                                                    @confirm="confirmwork" />
                                            </van-popup>
                                        </van-col>
                                        <van-col :span="11">
                                            <van-field
                                                v-model="item.percent"
                                                label="占比"
                                                :border="true"
                                                placeholder="请输入" />
                                        </van-col>
                                        <van-col :span="1" class="icon-style">
                                            <van-icon name="plus" @click="addWorkOrder" />
                                        </van-col>
                                        <van-col :span="1" @click="deltWorkOrder(index)">
                                            <span style="font-size:20px;margin-top:5px;">{{ item.deltBtn }}</span>
                                        </van-col>
                                    </van-row>
                                </div>
                                <van-field
                                    v-model="maintainItemdetails.enumFaultReasonname"
                                    readonly
                                    :required="true"
                                    :show-error="true"
                                    name="故障原因"
                                    label="故障原因"
                                    placeholder="故障原因"
                                    :rules="[ { required: true, message: '必填' } ]"
                                    @click="showenumFaultReason = true" />
                                <van-popup
                                    v-model="showenumFaultReason"
                                    position="bottom">
                                    <van-picker
                                        item-height="1.173rem"
                                        show-toolbar
                                        :columns="enumFaultReasons"
                                        @cancel="showenumFaultReason = false"
                                        @confirm="confirmenumFaultReason" />
                                </van-popup>
                                <van-field
                                    v-model="maintainItemdetails.totalPrice"
                                    disabled
                                    :show-error="true"
                                    name="合计金额"
                                    label="合计金额"
                                    placeholder="合计金额"
                                    class="moneyColor" />
                                <div class="nextClass">
                                    <Button v-if="!form.isOnlyRequisitionPart" round block type="info"
                                        native-type="submit" class="nextSpan">
                                        保存
                                    </Button>
                                </div>
                            </van-popup>
                        </div>
                    </van-form>

                    <van-row v-if="$_has('maintain:workorder:edit')" gutter="20" style="margin-top:1.2rem;padding:0 1rem;">
                        <van-col span="12">
                            <van-button round type="primary" block class="nextSpan"
                                @click="zancun">暂存</van-button>
                        </van-col>
                        <van-col span="12">
                            <van-button round type="primary" block class="nextSpan"
                                @click="submit">提交</van-button>
                        </van-col>
                    </van-row>
                </Tab>
            </Tabs>
        </div>
        <Repairpopup
            v-if="equiTimingRunVisible"
            ref="dalong"
            :visible.sync="equiTimingRunVisible"
            :modal-obj="modalObj" />
        <el-dialog
            :close-on-click-modal="false"
            title="保养提醒/缺件到货提醒"
            :visible.sync="centerDialogVisible"
            width="80%">
            <p v-if="maintainStatus == 1">{{ maintainMessage }}</p>
            <br>
            <p v-if="maintenanceStatus == 1">上次维修缺件已到货是否进行继续维修</p>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="displaycancles">取消并不再提醒</el-button>
                <el-button size="mini" @click="centerDialogVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="displaymplists">确 定</el-button>
            </span>
        </el-dialog>
        <bottom />
    </div>
</template>

<script>
var moment = require('moment')
import { Button, Tab, Tabs, NavBar, Form, Toast, Dialog } from 'vant'
import bottom from '@/components/bottom'
import { getrepair, displayreminder, displayteam, GetworkerByMtId, WorkOrdertempSave, WorkOrdercommit, getWorkOrder, WorkOrderhistoryList, entrancequery, displaymplist, displaycancle, awmFaultprocess } from '@/api/maintain'
import { getcategory, getvehicleCodeList, getCarDetails, getDriverList, getMaintenitemlistForDropdw, getDictionarySelect, getVehiclepositList, setParameter, queryhours, getOdd, getbarCodeList, getvehicleInfoItem } from '@/api/basics'
import { mapGetters } from 'vuex'
import Repairpopup from './components/repairpopup.vue'

export default {
    name: 'DispatchList',
    components: {
        bottom,
        [Button.name]: Button, NavBar, Tab, Tabs, Form, Button, Repairpopup, Dialog

    },
    data() {
        return {
            show: false,
            modalObj: {
                title: '维修历史',
                tableData: [],
                item: null
            },
            centerDialogVisible: false,
            // unitpricereadonly: true,
            equiTimingRunVisible: false,
            showenumFaultReason: false,
            showwork: false,
            showteam: false,
            showpart: false,
            showpositions: false,
            showmaintainItems: false,
            chosenContactId: null,
            editingContact: {},
            showList: false,
            showEdit: false,
            isEdit: false,
            projectreadonly: false,
            form: {
                driverSign: null,
                dispatcherSign: null,
                oldnum: null,
                sheetNo: null,
                id: uuid(),
                enumWorkOrderType: 1,
                enumWorkOrderStatus: 1, // 单据状态
                vehicleCode: null, // 车辆编号
                barCode: null, // 条码编号
                category: null, // 车辆类别
                brand: null, // 品牌
                model: null, // 型号
                customer: null, // 客户名称
                phone: null, // 电话
                owner: null, // 权责人
                driver: null, // 驾驶员
                drivers: [], // 驾驶员电话+号码
                driverPhone: null, // 驾驶员电话
                entryTime: null, // 入场时间
                enumMaintenanceType: 1, // 维修类型
                faultDescription: null, // 故障描述
                items: [

                ], // 维修项目
                checkedDrivers: [],
                enumMaintenanceName: '现场维修'
            },
            maintainItemdetails: {
                workOrderMen: [{ workerId: null, workerName: null, percent: null }],
                maintainItemNum: '',
                workHour: '',
                unitPrice: null,
                id: uuid(),
                partId: null,
                part: null,
                position: null,
                maintainItemId: null

            },
            maintainStatus: null,
            maintenanceStatus: null,
            tabdisabled: true,
            title: '派工单',
            jbinfo: null,
            teamNames: [],
            parts: [],
            positions: [],
            maintainItemslist: [],
            num: null,
            driversColumn: [],
            showdrivers: false,
            showpicker: false,
            activeName: 'a',
            finishedText: '已加载全部',
            refreshing: false,
            loading: false,
            finished: false,
            workers: [],
            vehicleCodeColumn: [],
            value1: 0,
            value2: '',
            enumFaultReasons: [
                { text: '自然损坏', value: 1 },
                { text: '驾驶操作', value: 2 },
                { text: '配件质量', value: 3 },
                { text: '维修装配', value: 4 }
            ],
            option2: [],
            resData: [],
            isTeam: false, // 维修队是否可改
            showbarCode: false, // 条码编号下拉框
            barCodeColumn: [] // 条码编号下拉框数据
        }
    },

    computed: {
        ...mapGetters([
            'companyId'
        ])
    },
    watch: {
        'maintainStatus'(val) {
            if (val == 1) {
                this.centerDialogVisible = true
            }
        },
        'maintenanceStatus'(val) {
            if (val == 1) {
                this.centerDialogVisible = true
            }
        },
        'activeName'(val) {
            console.log(val, this.$route.query.type)
            if (!this.$route.query.type || val == 'a') {
                this.tabdisabled = true
            }
        },
        'maintainItemdetails.maintainItemNum'(val) {
            if (!val || val == 0) {
                this.maintainItemdetails.totalPrice = (Number(this.maintainItemdetails.workHour) * Number(this.maintainItemdetails.unitPrice)).toFixed(2)
            } else {
                this.maintainItemdetails.totalPrice = (Number(val) * this.maintainItemdetails.workHour * this.maintainItemdetails.unitPrice).toFixed(2)
            }
        },
        'maintainItemdetails.workHour'(val) {
            if (!val || val == 0) {
                this.maintainItemdetails.totalPrice = 0
            } else if (!this.maintainItemdetails.maintainItemNum || this.maintainItemdetails.maintainItemNum == 0) {
                this.maintainItemdetails.totalPrice = (Number(val) * this.maintainItemdetails.unitPrice).toFixed(2)
            } else {
                console.log(this.maintainItemdetails.maintainItemNum)
                this.maintainItemdetails.totalPrice = (this.maintainItemdetails.maintainItemNum * Number(val) * this.maintainItemdetails.unitPrice).toFixed(2)
            }
        },
        'maintainItemdetails.unitPrice'(val) {
            if (!val || val == 0) {
                this.maintainItemdetails.totalPrice = 0
            } else if (!this.maintainItemdetails.maintainItemNum || this.maintainItemdetails.maintainItemNum == 0) {
                this.maintainItemdetails.totalPrice = (Number(val) * this.maintainItemdetails.workHour).toFixed(2)
            } else {
                console.log(this.maintainItemdetails.maintainItemNum)
                this.maintainItemdetails.totalPrice = (this.maintainItemdetails.maintainItemNum * Number(val) * this.maintainItemdetails.workHour).toFixed(2)
            }
        }
    },
    mounted() {
        if (this.$route.query.type != '处理') {
            this.getOdd()
        }
        this.getDetails()
    },
    created() {
        // 维修部位
        getDictionarySelect({ Code: 'Maintain:PositionsType' }).then(res => {
            if (res.code === 200) {
                this.positions = res.data
                res.data.forEach(item => {
                    item.text = item.name
                })
                this.positions = res.data
            }
        })
        // this.setParameters()
        this.getDetails()
    },
    // activated() {
    //     // this.setParameters()
    //     this.getDetails()
    // },
    methods: {
        pickuponly(val) {
            console.log(val)
            if (val) {
                this.form.items = []
                this.form.items.push({
                    id: uuid(),
                    workOrderId: this.form.id,
                    maintainItemId: null,
                    maintainItem: '仅领件',
                    partId: null,
                    part: null,
                    position: null,
                    workHour: 0,
                    unitPrice: 0,
                    maintainItemNum: 0,
                    teamId: null,
                    teamName: '仅领件',
                    teamOrgNodeId: null,
                    totalPrice: null,
                    enumFaultReason: 1,
                    disabled: false,
                    billDetailList: [],
                    enumQualityInspectionResult: 1,
                    parts: [],
                    workOrderMen: [{ workerId: 1, workerName: '仅领件', percent: 100 }]
                })
            } else {
                this.form.items = []
            }
        },
        original() {
            if (this.$_has('maintain:workorder:view')) {
                this.$router.push({ path: '/dispatchList', query: { id: this.form.sourceId, type: '处理' }})
                // this.$route.query.type = '处理'
                // this.$route.query.id = this.form.sourceId
                this.getDetails()
            } else {
                this.$router.push({
                    path: '/404'
                })
            }
        },
        // 路由跳转初始化
        async    getDetails() {
            if (this.$route.query.type == '处理') {
                this.cardisabled = true
                this.activeName = 'a'
                await awmFaultprocess([this.$route.query.id]).then(async res => {
                    console.log(res.data)
                    this.resData = JSON.parse(JSON.stringify(res.data.items))
                    if (res.data.items.length > 0) {
                        res.data.items.forEach((data, index) => {
                            data.teamNames = ''
                            data.index = index
                            if (data.workOrderMen.length > 0) {
                                data.workOrderMen.forEach(item => {
                                    data.workerNames = data.workOrderMen.map(function(obj) {
                                        return obj.workerName
                                    }).join(',')
                                })
                            }
                        })
                    }
                    this.form.vehicleCode = res.data.vehicleCode
                    this.form.customerId = res.data.customerId
                    await this.getHandList()
                    console.log(this.driversColumn, res.data.drivers, '2323')

                    if (this.driversColumn) {
                        this.driversColumn.forEach(element => {
                            res.data.drivers.forEach(items => {
                                if (element.driverNamePhone == items) {
                                    element.checked = true
                                }
                            })
                        })
                    }
                    const arr = this.driversColumn.filter(function(obj) {
                        return obj.checked
                    })
                    res.data.driversnamephone = arr.map(function(obj) {
                        return obj.driverNamePhone
                    }).join(',')
                    res.data.checkedDrivers = res.data.driversnamephone.split(',')
                    res.data.enumMaintenanceType == 1 ? res.data.enumMaintenanceName = '现场维修' : res.data.enumMaintenanceName = '场内维修'
                    res.data.enumWorkOrderType == 2 ? this.title = '返修派工单' : this.title = '派工单'
                    this.form = res.data
                    getMaintenitemlistForDropdw({ ModelIdStr: this.form.modelId }).then(res => {
                        console.log(res)
                        res.data.pagerData.forEach(item => {
                            item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                        })
                        this.maintainItemslist = res.data.pagerData
                    })
                })
            } else if (this.$route.query.type == '入场处理') {
                entrancequery(this.$route.query.id).then(async res => {
                    this.form.customerId = res.data.customerId
                    this.form.enumMaintenanceName = '场内维修'
                    this.form.enumMaintenanceType = 2
                    await this.getHandList()
                    this.driversColumn.forEach(element => {
                        res.data.drivers.forEach(items => {
                            if (element.driverNamePhone == items) {
                                element.checked = true
                            }
                        })
                    })
                    const arr = this.driversColumn.filter(function(obj) {
                        return obj.checked
                    })
                    this.form.driversnamephone = arr.map(function(obj) {
                        return obj.driverNamePhone
                    }).join(',')
                    this.form.checkedDrivers = this.form.driversnamephone.split(',')
                    this.form.entranceId = res.data.id
                    this.form.machineModelId = res.data.modelId
                    this.form.category = res.data.category
                    this.form.barCode = res.data.barCode
                    this.form.owner = res.data.owner
                    this.form.vehicleCode = res.data.vehicleCode
                    this.form.customer = res.data.customer
                    this.form.brand = res.data.brand
                    this.form.model = res.data.model
                    this.form.drivers = res.data.drivers
                    this.form.entryTime = res.data.entryTime
                    this.form.driver = res.data.driverName
                    this.form.driverPhone = res.data.driverPhone
                    this.form.vehicleId = res.data.vehicleId
                    this.form.outStockType = res.data.outStockType
                    this.form.phone = null
                    this.chidisabled = true
                    getMaintenitemlistForDropdw({ ModelIdStr: this.form.modelId }).then(res => {
                        console.log(res)
                        res.data.pagerData.forEach(item => {
                            item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                        })
                        this.maintainItemslist = res.data.pagerData
                    })
                })
                this.displayreminders(this.form.vehicleId)
            } else if (this.$route.query.type == '返修派工单') {
                this.title = this.$route.query.type
                getrepair(this.$route.query.id).then(async res => {
                    res.data.oldnum = res.data.sheetNo
                    res.data.enumMaintenanceType == 1 ? res.data.enumMaintenanceName = '现场维修' : res.data.enumMaintenanceName = '场内维修'
                    this.activeName = 'a'
                    await this.getHandList()
                    console.log(this.driversColumn,)
                    if (this.driversColumn) {
                        this.driversColumn.forEach(element => {
                            res.data.drivers.forEach(items => {
                                if (element.driverNamePhone == items) {
                                    element.checked = true
                                }
                            })
                        })
                    }
                    const arr = this.driversColumn.filter(function(obj) {
                        return obj.checked
                    })
                    res.data.driversnamephone = arr.map(function(obj) {
                        return obj.driverNamePhone
                    }).join(',')
                    res.data.checkedDrivers = res.data.driversnamephone.split(',')
                    this.form = res.data
                    this.form.enumWorkOrderStatus = 1
                    this.form.enumWorkOrderType = 2
                    this.form.items.forEach(item => {
                        item.disabled = true
                        item.id = uuid()
                        item.workOrderMen.forEach(ite => {
                            ite.id = uuid()
                        })
                    })
                    this.form.id = uuid()
                    getMaintenitemlistForDropdw({ ModelIdStr: this.form.modelId }).then(res => {
                        console.log(res)
                        res.data.pagerData.forEach(item => {
                            item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                        })
                        this.maintainItemslist = res.data.pagerData
                    })
                })
            }
        },
        // 取消保养提醒
        displaycancles() {
            const param = {
                maintainStatus: this.maintainStatus,
                maintenanceStatus: this.maintenanceStatus,
                vehicleId: this.form.vehicleId,
                vehicleCode: this.form.vehicleCode
            }
            displaycancle(param).then(res => {
                if (res.isSuccess) {
                    this.$message({
                        message: res.message,
                        type: 'success'
                    })
                    this.centerDialogVisible = false
                }
            })
        },
        // 项目详情
        details(item, index) {
            console.log(item, '项目详情')
            if (item.workOrderMen.length == 0) {
                item.workOrderMen = [{ workerId: null, workerName: null, percent: null }]
            }
            this.maintainItemdetails = JSON.parse(JSON.stringify(item))

            this.maintainItemdetails.enumFaultReasonname = this.convertStatus(this.maintainItemdetails.enumFaultReason)
            this.showList = true
            if (index == 0 && this.form.enumWorkOrderStatus === 1) {
                this.isTeam = false
            } else {
                this.isTeam = true
            }
        },
        activetab() {
            this.onSubmit()
        },
        // 缺件确定
        displaymplists() {
            if (this.maintenanceStatus == 1) {
                displaymplist(this.form.vehicleId).then(res => {
                    res.data.forEach(item => {
                        if (item.workOrderMen.length == 0) {
                            item.workOrderMen = [{ workerId: null, workerName: null, percent: null }]
                        }
                    })
                    this.form.items = res.data
                    this.centerDialogVisible = false
                })
            } else {
                this.centerDialogVisible = false
            }
        },
        // 提交
        submit() {
            if (!this.jbinfo) {
                Toast.fail('请检查必填项')
                return
            }
            if (this.form.items.length == 0) {
                Toast.fail('请添加维修项目数据')
                return
            }
            // console.log(11111,this.$route.query.type)
            if (!this.$route.query.type || this.$route.query.type == '返修派工单' || this.$route.query.type == '入场处理') {
                this.form.sheetNo = this.sheetNos
                this.form.id = uuid()
            }
            this.form.items && this.form.items.forEach(item => {
                item.workOrderMen = item.workOrderMen.filter(items => {
                    return items.workerId
                })
            })
            console.log('提交信息', this.form)
            // return
            WorkOrdercommit(this.form).then(res => {
                if (res.code === 200) {
                    Toast.success(res.message)
                    if (this.$_has('maintain:workorder:view')) {
                        this.$router.push({ path: '/dispatching' })
                    } else {
                        this.$router.push({
                            path: '/404'
                        })
                    }
                }
            })
        },
        // 暂存
        zancun() {
            if (!this.$route.query.type || this.$route.query.type == '返修派工单' || this.$route.query.type == '入场处理') {
                this.form.sheetNo = this.sheetNos
                this.form.id = uuid()
            }
            this.form.items && this.form.items.forEach(item => {
                item.workOrderMen = item.workOrderMen.filter(items => {
                    return items.workerId
                })
            })
            WorkOrdertempSave(this.form).then(res => {
                console.log(res)
                if (res.isSuccess) {
                    Toast(res.message)
                    if (this.$_has('maintain:workorder:view')) {
                        this.$router.push({ path: '/dispatching' })
                    } else {
                        this.$router.push({
                            path: '/404'
                        })
                    }
                }
            })
            console.log(this.form)
        },
        PrefixInteger(num, length) {
            return (Array(length).join('0') + num).slice(-length);
        },
        // 生成单号
        getOdd() {
            let tenantCode = null
            if (!this.$store.state.user.userInfo.tenantId) {
                tenantCode = '0000'
            }else{
                tenantCode = this.PrefixInteger(this.$store.state.user.userInfo.tenantId,4)
            }
            var sheetNo = `PG${tenantCode}${moment().format('YYYY')}${moment().format('MM')}${moment().format('DD')}`
            getOdd(sheetNo)
                .then(res => {
                    if (res.isSuccess) {
                        this.sheetNos = res.data.sheetNo
                        console.log(res.data, '单号')
                    }
                })
        },
        // 维修队筛选
        async teamlist() {
            if (this.isTeam) {
                this.showteam = false
                return
            }
            if (!this.isTeam) {
                this.showteam = true
            }
            const res = await displayteam(this.maintainItemdetails.maintainItemId)
            res.data.pagerData.forEach(item => {
                item.text = item.teamName
            })
            this.teamNames = res.data.pagerData
        },
        // // 获取工时单价
        // setParameters() {
        //     setParameter({ OrgId: this.companyId }).then(res => {
        //         if (res.code === 200) {
        //             this.unitPrice = res.data.WorkHourPrice || 0
        //             this.maintainItemdetails.unitPrice = res.data.WorkHourPrice || 0
        //         }
        //     })
        // },
        // 部件列表
        bwpart() {
            // 部件列表
            getVehiclepositList({ positionsName: [this.maintainItemdetails.position], partName: '', startTime: '', endTime: '', PageSize: 10000, PageIndex: 1, allData: 2 }).then(res => {
                if (res.data) {
                    res.data.pagerData.forEach(item => {
                        item.text = item.partName
                    })
                    this.parts = res.data.pagerData
                    this.showpart = true
                } else {
                    this.parts = []
                    this.showpart = false
                }
            })
        },
        // 确认故障原因
        confirmenumFaultReason(val) {
            console.log(val)
            this.enumFaultReasons.forEach(res => {
                if (res.text == val.text) {
                    this.maintainItemdetails.enumFaultReason = res.value
                    this.maintainItemdetails.enumFaultReasonname = res.text
                    this.showenumFaultReason = false
                }
                // if(val.text)
            })

            if (val.text == '配件质量' || val.text == '维修装配') {
                this.equiTimingRunVisible = true
                // this.showList = false
                WorkOrderhistoryList({ vehicleId: this.form.vehicleId, maintainItemId: this.maintainItemdetails.maintainItemId, partId: null }).then(res => {
                    this.modalObj.tableData = res.data
                })
            }
        },
        // 维修队确认
        confirmteam(val) {
            console.log(val)
            this.teamNames.forEach(res => {
                if (res.teamId == val.teamId) {
                    this.maintainItemdetails.teamName = res.teamName
                    this.maintainItemdetails.teamId = res.teamId
                    this.maintainItemdetails.workOrderMen.forEach(element => {
                        element.workerId = null
                        element.workerName = null
                        element.percent = null
                    })
                    this.maintainItemdetails.teamOrgNodeId = res.orgNodeId
                    this.showteam = false
                }
            })
            this.form.items && this.form.items.forEach(item => {
                item.workOrderMen && item.workOrderMen.forEach(workItem => {
                    workItem.workerId = null
                    workItem.workerName = null
                    workItem.percent = null
                })
                item.workerNames = null
            })
        },
        // 获取维修工
        async getWorkers(val) {
            console.log(val)
            this.index = val
            const res = await GetworkerByMtId({ MaintenanceTeamID: this.maintainItemdetails.teamId })
            if (res.isSuccess) {
                res.data && res.data.forEach(item => {
                    item.text = item.workerName
                })
            }
            if (res.data.length == 0) {
                return
            }
            this.workers = res.data
            this.showwork = true
        },
        // 点击维修工加号
        addWorkOrder() {
            this.maintainItemdetails.workOrderMen.push({ workerName: '', percent: '', deltBtn: '-' })
        },
        // 确认部位
        confirmposition(val) {
            this.maintainItemdetails.part = ''
            this.maintainItemdetails.partId = ''
            this.positions.forEach(res => {
                if (res.id == val.id) {
                    this.maintainItemdetails.position = res.name

                    this.showpositions = false
                }
            })
        },
        // 点击减号删除
        deltWorkOrder(index) {
            this.maintainItemdetails.workOrderMen.splice(index, 1)
        },
        // 确认维修项目
        confirmmaintainItem(val) {
            console.log(val)
            this.maintainItemslist.forEach(async res => {
                if (res.id == val.id) {
                    this.maintainItemdetails.enumMaintenType = res.enumMaintenType
                    this.maintainItemdetails.maintainItem = res.code + '-' + res.name + '-' + res.maintenTypeName
                    this.maintainItemdetails.maintainItemId = res.id
                    this.showmaintainItems = false
                    this.maintainItemdetails.workHour = res.hours
                    this.maintainItemdetails.unitPrice = res.price
                    // await queryhours({ maintenItemId: res.id, modelId: this.form.modelId || this.form.machineModelId }).then(res => {
                    //     if (res.data) {
                    //         this.maintainItemdetails.workHour = res.data.hours
                    //         this.maintainItemdetails.unitPrice = res.data.price
                    //     } else {
                    //         this.maintainItemdetails.workHour = null
                    //         this.maintainItemdetails.unitPrice = null
                    //     }
                    //     this.maintainItemdetails.maintainItemNum = null
                    // })
                }
            })
            // if (val) {
            //     this.projectreadonly = true
            //     // this.unitpricereadonly = true
            // } else {
            //     this.projectreadonly = false
            //     // this.unitpricereadonly = false
            // }
        },
        // 维修工确认确认
        confirmwork(event) {
            const { text, id } = event
            this.maintainItemdetails.workOrderMen[this.index].workerName = text
            this.maintainItemdetails.workOrderMen[this.index].workerId = id
            if (this.maintainItemdetails.workOrderMen.length == 1) {
                this.maintainItemdetails.workOrderMen[0].percent = 100
            }
            this.showwork = false
        },
        // 确认部件
        confirmpart(val) {
            this.parts.forEach(res => {
                if (res.id == val.id) {
                    this.maintainItemdetails.part = res.partName
                    this.maintainItemdetails.partId = res.id
                    this.showpart = false
                }
            })
        },
        // 维修项目列表
        showLists() {
            this.showList = true
            this.maintainItemdetails.id = uuid()
            console.log('是否有已提交的维修项目', this.form.items)
            if (this.form.items.length > 0) {
                this.maintainItemdetails.teamName = this.form.items[0].teamName
                this.maintainItemdetails.teamId = this.form.items[0].teamId
                this.maintainItemdetails.teamOrgNodeId = this.form.items[0].teamOrgNodeId
                this.isTeam = true
            } else {
                this.isTeam = false
            }
        },
        // 清空车辆编号
        closepopup() {
            if (!this.num) {
                this.form.vehicleCode = null
            }
        },
        // 先选车辆才有驾驶员
        async    showdriver() {
            if (!this.form.vehicleCode) {
                Toast('请先选择车辆')
            } else if (this.form.enumWorkOrderStatus != 1 || this.title == '返修派工单') {
                return
            } else {
                // if (!this.form.driversnamephone) {
                //     await this.getHandList()
                // }
                if (this.driversColumn.length == 0) {
                    this.showdrivers = false
                } else {
                    this.showdrivers = true
                }
            }
        },
        // 选择驾驶员
        toggle(item, index) {
            console.log(this.driversColumn, index)
            if (item.checked == false) {
                console.log(this.$refs.checkboxes.length)
                item.checked = true
                this.$refs.checkboxes[index].toggle()
            } else {
                console.log(1111)
                item.checked = false
                this.$refs.checkboxes[index].toggle()
            }
            const arr = this.driversColumn.filter(function(obj) {
                return obj.checked
            })
            this.form.driversnamephone = arr.map(function(obj) {
                return obj.driverNamePhone
            }).join(',')
            this.form.drivers = this.form.driversnamephone.split(',')
            console.log(this.driversColumn, '121212')
        },
        // 驾驶员下拉
        async    getHandList() {
            if (!this.form.customerId) {
                this.driversColumn = []
                return
            }
            const param = {
                PageIndex: 1,
                PageSize: 10000,
                customerId: this.form.customerId
            }
            this.form.driver = null
            await getDriverList(param).then(res => {
                if (res.isSuccess) {
                    res.data.pagerData.forEach(item => {
                        item.driverNamePhone = item.name + '-' + item.contactNo
                        item.checked = false
                    })
                    this.driversColumn = res.data.pagerData
                }
            })
        },
        onConfirm(val) {
            this.num = val
            console.log(val, this.vehicleCodeColumn)
            const res = this.vehicleCodeList.filter(item => {
                return item.code == val
            })
            this.form.outStockType = res[0].outStockType
            this.form.customerId = res[0].customerId

            getCarDetails(res[0].id).then(async res => {
                this.carid = val
                await this.getHandList()
                this.form.category = res.data.machineCategoryName
                this.form.barCode = res.data.barCode
                this.form.owner = res.data.ownerNames
                // if (res.data.vehicleDrivers) {
                //     res.data.vehicleDrivers.forEach(item => {
                //         item.driverNamePhone = item.driverName + '-' + item.driverPhone
                //         this.form.checkedDrivers.push(item.driverName + '-' + item.driverPhone)
                //     })
                //     this.form.driversnamephone = res.data.vehicleDrivers.map(function(obj) {
                //         return obj.driverNamePhone
                //     }).join(',')
                //     this.form.drivers = this.form.driversnamephone.split(',')
                //     this.driversColumn.forEach(element => {
                //         this.form.driversnamephone.split(',').forEach(items => {
                //             if (element.driverNamePhone == items) {
                //                 element.checked = true
                //             }
                //         })
                //     })
                // } else {
                //     this.form.checkedDrivers = []
                // }
                this.form.modelId = res.data.machineModelId
                this.form.machineModelId = res.data.machineModelId
                this.form.vehicleCode = res.data.code
                this.form.customer = res.data.customerName
                this.form.brand = res.data.machineBrandName
                this.form.model = res.data.machineModel
                // this.form.driver = res.data.driverName
                this.form.driverPhone = res.data.driverPhone
                this.form.vehicleId = res.data.id
                this.form.phone = null
                // if (!res.data.barCode) {
                //     this.$message({
                //         message: '请先维护该车辆档案的条码编号',
                //         type: 'error'
                //     })
                // }
                this.displayreminders(this.form.vehicleId)
                this.showpicker = false
            })
        },
        // 保养提醒
        displayreminders(vehicleId) {
            displayreminder(vehicleId).then(res => {
                if (res.data) {
                    this.maintainStatus = res.data.maintainStatus
                    this.maintenanceStatus = res.data.maintenanceStatus
                    this.maintainMessage = res.data.maintainMessage
                }
            })
        },
        // 根据车辆变化查询
        queryvehicleCode() {
            //  Toast(1);
            // var data={};
            // data.code=this.vehicleCode;
            this.num = null
            this.vehicleCodeColumn = []
            var refData = []
            if (!this.form.vehicleCode) {
                return
            }
            getvehicleCodeList(this.form.vehicleCode).then((res) => {
                if (res.code == 200) {
                    this.vehicleCodeList = res.data
                    if (this.vehicleCodeList.length > 0) {
                        var i = 0
                        for (i; i < this.vehicleCodeList.length; i++) {
                            refData[i] = this.vehicleCodeList[i].code
                        }
                    }
                    this.vehicleCodeColumn = refData
                    this.showpicker = true
                    // Notify({ type: 'success', message: this.vehicleCodeList.length });
                } else {
                    Toast(res.message)
                }
            })
        },
        // 条码编号搜索
        querybarCode() {
            //  Toast(1);
            // var data={};
            // data.code=this.vehicleCode;
            this.barCodeColumn = []
            var refData = []

            getbarCodeList(this.form.barCode).then((res) => {
                if (res.code == 200) {
                    this.barCodeList = res.data
                    console.log(this.barCodeList)
                    if (this.barCodeList.length > 0) {
                        var i = 0
                        for (i; i < this.barCodeList.length; i++) {
                            refData[i] = this.barCodeList[i].barCode
                        }
                    }
                    this.barCodeColumn = refData
                    this.showbarCode = true
                    // Notify({ type: 'success', message: this.vehicleCodeList.length });
                } else {
                    Toast(res.message)
                }
            })
        },
        // 条码编号确认
        barcodeConfirm(val) {
            this.num = val
            console.log(val, this.barCodeColumn)
            const res = this.barCodeList.filter(item => {
                return item.barCode == val
            })
            console.log(111111, res)
            this.form.outStockType = res[0].outStockType
            this.form.customerId = res[0].customerId

            getvehicleInfoItem(res[0].id).then(async res => {
                this.carid = val
                await this.getHandList()
                this.form.category = res.data.machineCategoryName
                this.form.barCode = res.data.barCode
                this.form.owner = res.data.ownerNames
                this.form.modelId = res.data.machineModelId
                this.form.machineModelId = res.data.machineModelId
                this.form.vehicleCode = res.data.code
                this.form.customer = res.data.customerName
                this.form.brand = res.data.machineBrandName
                this.form.model = res.data.machineModel
                // this.form.driver = res.data.driverName
                this.form.driverPhone = res.data.driverPhone
                this.form.vehicleId = res.data.id
                this.form.phone = null
                this.displayreminders(this.form.vehicleId)
                this.showbarCode = false
            })
        },
        clearbarCode() {
            console.log('clearvehicleCode')
            this.form.barCode = ''
        },
        clearvehicleCode() {
            console.log('clearvehicleCode')
            this.form.vehicleCode = ''
        },
        // 维修项目模糊搜索
        async queryMaintainItem() {
            this.maintainItemslist = []
            if (this.maintainItemdetails.maintainItem) {
                const res = await getMaintenitemlistForDropdw({ 'keywords': this.maintainItemdetails.maintainItem, ModelIdStr: this.form.modelId, 'beginDate': '', 'endDate': '', 'maintenTypeIds': [], 'PageSize': 20, 'PageIndex': 1 })
                res.data.pagerData.forEach(item => {
                    item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                })
                var authorityadmin = res.data.pagerData.filter(itmer => itmer.text.indexOf(this.maintainItemdetails.maintainItem) === -1)
                if (authorityadmin.length == 0) {
                    this.maintainItemslist = res.data.pagerData
                    // this.maintainItemslistCopy = JSON.parse(JSON.stringify(res.data.pagerData || []))
                }
                // this.maintainItemslist = res.data.pagerData
            } else {
                const res = await getMaintenitemlistForDropdw({ 'keywords': '', ModelIdStr: this.form.modelId, 'beginDate': '', 'endDate': '', 'maintenTypeIds': [], 'PageSize': 20, 'PageIndex': 1 })
                res.data.pagerData.forEach(item => {
                    item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                })
                this.maintainItemslist = res.data.pagerData
            }
            console.log('维修项目', this.maintainItemslist.length)
            if (this.maintainItemslist.length == 0) {
                this.maintainItemdetails.maintainItemId = null
                this.maintainItemdetails.workHour = null
                this.maintainItemdetails.unitPrice = null
                this.maintainItemdetails.maintainItemNum = null
            }
        },
        // 驾驶员下拉
        async queryDrivers() {
            if (this.form.enumWorkOrderStatus == 1) {
                this.showdrivers = true
            } else {
                this.showdrivers = false
                return
            }
            this.driversColumn = []
            if (!this.form.customerId) {
                this.driversColumn = []
                return
            }
            const param = {
                PageIndex: 1,
                PageSize: 10000,
                customerId: this.form.customerId
            }
            this.form.driver = null
            await getDriverList(param).then(res => {
                if (res.isSuccess) {
                    res.data.pagerData.forEach(item => {
                        item.driverNamePhone = item.name + '-' + item.contactNo
                        item.checked = false
                    })
                    this.driversColumn = res.data.pagerData
                    if (this.driversColumn) {
                        this.driversColumn.forEach(element => {
                            this.form.driversnamephone.split(',').forEach(items => {
                                if (element.driverNamePhone == items) {
                                    element.checked = true
                                }
                            })
                        })
                    } else {
                        this.form.checkedDrivers = []
                    }
                }
            })
        },
        closeshowList() {
            console.log(192)
            this.maintainItemdetails.maintainItemNum = null
            this.maintainItemdetails.workHour = null
            this.maintainItemdetails.position = null
            this.maintainItemdetails.part = null
            this.maintainItemdetails.teamName = null
            this.maintainItemdetails.maintainItem = null
            this.maintainItemdetails.partId = null
            this.maintainItemdetails.maintainItemId = null
            this.maintainItemdetails.unitPrice = null
            this.maintainItemdetails.workerNames = null
            this.maintainItemdetails.workHour = null
            this.maintainItemdetails.enumFaultReasonname = null
            this.maintainItemdetails.enumFaultReason = null
            this.maintainItemdetails.totalPrice = 0
            this.maintainItemdetails.workOrderMen = [{ workerId: null, workerName: null, percent: null }]
            this.projectreadonly = false
        },
        async    onSubmits(val) {
            if (val) {
                this.maintainItemdetails.workOrderMen = this.maintainItemdetails.workOrderMen.filter(item => {
                    return item.workerId
                })
                this.maintainItemdetails.workerNames = this.maintainItemdetails.workOrderMen.map(function(obj) {
                    return obj.workerName
                }).join(',')
                console.log(this.maintainItemdetails.id, 234923)
                // this.form.items.forEach(res => {
                //     if (res.id == this.maintainItemdetails.id) {
                //         res = this.maintainItemdetails
                //     } else {
                //         this.form.items.push(JSON.parse(JSON.stringify(this.maintainItemdetails)))
                //     }
                // })
                let index = ''
                for (let i = 0; i < this.form.items.length; i++) {
                    if (this.maintainItemdetails.id == this.form.items[i].id) {
                        index = i
                    }
                }
                if (this.form.items.findIndex(item => item.id === this.maintainItemdetails.id) > -1) {
                    await this.form.items.splice(this.form.items.findIndex(item => item.id === this.maintainItemdetails.id), 1)
                    // this.form.items.push(JSON.parse(JSON.stringify(this.maintainItemdetails)))
                    this.form.items.splice(index, 0, JSON.parse(JSON.stringify(this.maintainItemdetails)))
                } else {
                    this.form.items.push(JSON.parse(JSON.stringify(this.maintainItemdetails)))
                    // this.form.items.splice(index, 0, JSON.parse(JSON.stringify(this.maintainItemdetails)))
                }
                // this.form.items.findIndex(item => item.id === this.maintainItemdetails.id)
                // console.log(this.form.items.findIndex(item => item.id === this.maintainItemdetails.id))
                // await this.form.items.splice(this.form.items.findIndex(item => item.id === this.maintainItemdetails.id), 1)
                // console.log(this.form.items)
                // this.form.items.push(JSON.parse(JSON.stringify(this.maintainItemdetails)))
                this.maintainItemdetails.maintainItemNum = null
                this.maintainItemdetails.workHour = null
                this.maintainItemdetails.position = null
                this.maintainItemdetails.part = null
                this.maintainItemdetails.teamName = null
                this.maintainItemdetails.maintainItem = null
                this.maintainItemdetails.partId = null
                this.maintainItemdetails.maintainItemId = null
                this.maintainItemdetails.unitPrice = null

                this.maintainItemdetails.workHour = null
                this.maintainItemdetails.workerNames = null
                this.maintainItemdetails.enumFaultReasonname = null
                this.maintainItemdetails.enumFaultReason = null
                this.maintainItemdetails.totalPrice = 0
                this.maintainItemdetails.workOrderMen = [{ workerId: null, workerName: null, percent: null }]

                this.showList = false
                console.log(this.form.items)
                this.form.items && this.form.items.forEach(item => {
                    item.teamName = this.form.items[0].teamName
                    item.teamId = this.form.items[0].teamId
                    item.teamOrgNodeId = this.form.items[0].teamOrgNodeId
                })
            }
        },
        onSubmit(values) {
            console.log(values)
            if (values) {
                console.log(this.form)
                if (this.form.drivers && this.form.drivers.length > 2) {
                    Toast.fail('最多绑定两个驾驶员')
                    return
                }
                this.tabdisabled = false
                this.jbinfo = values
                this.$nextTick(() => {
                    this.activeName = 'b'
                })
            }
        },
        routeto() {
            this.$router.push({ path: '/partsrepair', query: { keyword: this.form.barCode }})
        },
        getBack() {
            this.$router.back()
        },
        convertStatus(status) {
            switch (status) {
            case 1:
                return '自然损坏'
            case 2:
                return '驾驶操作'
            case 3:
                return '配件质量'
            case 4:
                return '维修装配'
            }
        }
    }
}
</script>

<style lang='scss' scoped>
.icon-style .van-icon{ margin-top: 0.23rem;}
.info-span-bottom{
    display:inline-block;
    padding:0px 8px;
    color:#000;
    width:46%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
</style>

